import { AppRecord, AppRecordStatus } from "models/appRecord";
import Religion from "pages/business-suite/dummyStaff";
import useUrlString from "pages/business-suite/useUrlString";

import { useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { AppLog } from "services";
import { useAppSelector } from "store/store";
import { RequestApi, RouteApi, StatusMsg } from "utils";
type WorkingHour = {
  starting_time: string;
  ending_time: string;
  no_of_working_hour: string;
  no_of_break_minute: string;
  break_starting_time: string;
  break_ending_time: string;
};
type FormData = {
  shift_group_id: any;
  shop_id: any;
  local_description: string;
  latitude: string;
  longitude: string;
  max_distance: string;
  working_hours: WorkingHour[];
};
const { days } = Religion();
const useStaffAction = () => {
  const { token } = useAppSelector((state) => state.auth);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [errorStatus, setErrorStatus] = useState({
    title: "",
    message: "",
  });
  const [warning, setWarning] = useState(false);
  const [loadingFetchDataDepartment, setLoadingFetchDataDepartment] = useState<boolean>(false);
  const [department, setDepartment] = useState<any>();
  const [alldepartment, setAllsetDepartment] = useState<any>();
  const [storage_host_cluster_Id, setStorage_host_cluster_Id] = useState<any>();
  const [userShopShiftGroup, setUserShopShiftGroup] = useState<any>();
  const [searchTextInput, setSearchTextInput] = useState<string>("");
  const [shopEmployee, setShopEmployee] = useState<any>();
  //   -----------------------------------
  const [shopEmployeeLoading, setShopEmployeeLoading] = useState<any>(null);
  const [shopEmployeeLoadingState, setShopEmployeeLoadingState] = useState<any>(null);
  const [view, setView] = useState("card");
  const [selectedProductGroupCode, setSelectedProductGroupCode] = useState<string>("");
  const selectedProductGroupCodeRef = useRef(selectedProductGroupCode);
  const [dobStaff, setDobStaff] = useState(new Date().toISOString().split("T")[0]); // "2025-05-05"
  const [shiftActive, setShiftActive] = useState<any>();

  const { btnToggle } = useAppSelector((state) => state.header);
  const fetchDepartment = async () => {
    setLoadingFetchDataDepartment(true);
    try {
      const url = `${RouteApi.getShopDepartment}token=${token}`;
      const data = {
        shop_id: shopId,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setAllsetDepartment(response["user_shop_departments"]);
        setStorage_host_cluster_Id(response.storage_host_cluster);
        setDepartment(response["departments"]);
        setUserShopShiftGroup(response["user_shop_shift_groups"]);
        setLoadingFetchDataDepartment(false);
      } else {
        setLoadingFetchDataDepartment(false);
        setErrorStatus({
          title: response.status,
          message: response.msg,
        });
        setWarning(true);
      }
    } catch (error: any) {
      setLoadingFetchDataDepartment(false);
      AppLog.show({
        message: `[fetchDepartment]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const getShopEmployeeSearch = async () => {
    setShopEmployeeLoadingState(true);
    try {
      const url = `${RouteApi.getShopEmployeeSearch}token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: searchTextInput,
        department: selectedProductGroupCode,
        is_deleted: btnToggle ? 1 : 0,
        working_date: dobStaff,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setShopEmployeeLoadingState(false);

        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: response["user_shop_employees"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: response["user_shop_employees"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        };
        setShopEmployee(response.user_shop_employees);

        setShopEmployeeLoading(stateRecord);
      } else {
        setShopEmployeeLoadingState(false);

        console.log(response, "error fetch shop employee ");
      }
    } catch (error: any) {
      setShopEmployeeLoadingState(false);

      AppLog.show({
        message: `[getShopEmployeeSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const loadingProductState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };
  const fetchMoreShopEmployeeSearch = async ({ next }: { next: string }) => {
    if (!next) return;

    setShopEmployeeLoading({
      ...loadingProductState,
      loadingStatus: AppRecordStatus.loadingMore,
    });

    try {
      const responses = await RequestApi(next);

      if (responses.status === "success") {
        const newEmployees = responses["user_shop_employees"]["data"];
        const nextPage = responses["user_shop_employees"]["next_page_url"];

        const updatedData = [...(shopEmployee?.data || []), ...newEmployees];

        setShopEmployee({
          ...responses["user_shop_employees"],
          data: updatedData,
        });

        setShopEmployeeLoading({
          ...loadingProductState,
          nextPageUrl: nextPage ?? "",
          loadingStatus: nextPage ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        });
      }
    } catch (error) {
      console.error("Failed to fetch more employees:", error);
    }
  };
  const handleClickCategory = ({ categoryName, groupId }: { categoryName: string; groupId: string }) => {
    if (selectedProductGroupCode === categoryName) return;
    setSelectedProductGroupCode(categoryName);
    selectedProductGroupCodeRef.current = categoryName;
  };

  // --------------------------
  const [loadingFetchDataShopEmployeeDetail, setLoadingFetchDataShopEmployeeDetail] = useState<boolean>(false);
  const [ShopEmployeeDetail, setShopEmployeeDetail] = useState<any>(null);
  const getShopEmployeeDetail = async (id: any) => {
    setLoadingFetchDataShopEmployeeDetail(true);
    try {
      const url = `${RouteApi.getShopEmployeeDetail}token=${token}`;
      const data = {
        shop_id: shopId,
        employee_id: id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingFetchDataShopEmployeeDetail(false);
        setShopEmployeeDetail(response.user_shop_employee);
      } else {
      }
    } catch (error: any) {
      setLoadingFetchDataShopEmployeeDetail(false);

      AppLog.show({
        message: `[submitUndoDeleteShopEmployee]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);
  const [selectProducts, setSelectProducts] = useState<boolean>(false);

  const submitDeleteShopEmployee = async () => {
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopEmployee;
      url += `token=${token}`;
      const data = {
        employee_ids: selectedProductIds,
        shop_id: shopId,
        permanence_deleted: btnToggle ? 2 : 0,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            setAllsetDepartment(responses.user_shop_departments);
            setShopEmployee((prevItemGroups: any) => {
              return {
                ...prevItemGroups,
                data: (prevItemGroups.data || []).filter((item: any) => !selectedProductIds.includes(item.id)),
              };
            });
            setSelectProducts(false);
            setSelectedProductIds([]);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[submitDeleteShopEmployee]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const { hanleClickRemoveURl } = useUrlString();
  const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);

  const submitDeleteShopEmployeeOnly = async () => {
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopEmployee;
      url += `token=${token}`;
      const data = {
        employee_ids: [ShopEmployeeDetail.id],
        shop_id: shopId,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses) {
            hanleClickRemoveURl("staff_id");
            setAllsetDepartment(responses?.user_shop_departments);
            setShopEmployee((prevItemGroups: any) => {
              return {
                ...prevItemGroups,
                data: (prevItemGroups.data || []).filter((item: any) => item.id !== responses.id),
              };
            });
            setOpenPopoverIndex(null);
            setShopEmployeeDetail(null);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[submitDeleteShopEmployee]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  const submitUndoDeleteShopEmployee = async () => {
    try {
      let url: string = "";
      url = RouteApi.submitUndoDeleteShopEmployee;
      url += `token=${token}`;
      const data = {
        employee_ids: selectedProductIds,
        shop_id: shopId,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            setAllsetDepartment(responses.user_shop_departments);
            setShopEmployee((prevItemGroups: any) => {
              return {
                ...prevItemGroups,
                data: (prevItemGroups.data || []).filter((item: any) => !selectedProductIds.includes(item.id)),
              };
            });
            setSelectProducts(false);
            setSelectedProductIds([]);
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      AppLog.show({
        message: `[submitUndoDeleteShopEmployee]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  return {
    getShopEmployeeDetail,
    loadingFetchDataShopEmployeeDetail,
    setLoadingFetchDataShopEmployeeDetail,
    // -------shopEmployee department-------
    fetchDepartment,
    errorStatus,
    setErrorStatus,
    warning,
    loadingFetchDataDepartment,
    setLoadingFetchDataDepartment,
    department,
    setDepartment,
    alldepartment,
    setAllsetDepartment,
    storage_host_cluster_Id,
    userShopShiftGroup,
    setUserShopShiftGroup,
    searchTextInput,
    setSearchTextInput,
    // ----------------------
    shopEmployee,
    shopEmployeeLoading,
    setShopEmployeeLoading,
    shopEmployeeLoadingState,
    setShopEmployeeLoadingState,
    setShopEmployee,
    view,
    setView,
    selectedProductGroupCode,
    setSelectedProductGroupCode,
    selectedProductGroupCodeRef,
    dobStaff,
    setDobStaff,
    getShopEmployeeSearch,
    fetchMoreShopEmployeeSearch,
    handleClickCategory,
    // -------------------
    submitDeleteShopEmployee,
    selectedProductIds,
    setSelectedProductIds,
    selectProducts,
    setSelectProducts,
    submitUndoDeleteShopEmployee,
    openPopoverIndex,
    setOpenPopoverIndex,
    submitDeleteShopEmployeeOnly,
  };
};

export default useStaffAction;
